var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "container-violation",
      class: { "ar-style": _vm.$i18n.locale === "ar" },
    },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `paddingTop:${_vm.barHeight}px`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: "", "left-arrow": "" },
            on: {
              "click-left": _vm.handleBack,
              "click-right": _vm.handleToRule,
            },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow05.png"),
                        alt: "",
                      },
                    }),
                    _c("span", { staticClass: "tit-left" }, [
                      _vm._v(_vm._s(_vm.$t("lang.vio.violation"))),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "right",
                fn: function () {
                  return [
                    _c("span", { staticClass: "tit-right" }, [
                      _c("img", {
                        staticClass: "left-nav",
                        attrs: {
                          src: require("@/assets/packageAssets/common/rules01.png"),
                          alt: "",
                        },
                      }),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c("div", { staticClass: "week-data-box right-read" }, [
        _c("div", { staticClass: "week-data" }, [
          _c("div", { staticClass: "data" }, [
            _c("div", { staticClass: "num" }, [
              _c("img", {
                staticClass: "img1",
                attrs: {
                  src: require("@/assets/packageAssets/views/P2_Page/Violation/vava/girl.png"),
                  alt: "",
                },
              }),
              _vm._v(" " + _vm._s(_vm.totalVioWeek) + " "),
            ]),
            _c("div", { staticClass: "text" }, [
              _vm._v(_vm._s(_vm.$t("lang.vio.totalVioWeek"))),
            ]),
          ]),
          _c("span", { staticClass: "line" }),
          _c("div", { staticClass: "data" }, [
            _c("div", { staticClass: "num" }, [
              _c("img", {
                staticClass: "img2",
                attrs: { src: _vm.getMatchImg("beans"), alt: "" },
              }),
              _vm._v(" " + _vm._s(_vm.totalDedWeek) + " "),
            ]),
            _c("div", { staticClass: "text" }, [
              _vm._v(_vm._s(_vm.$t("lang.vio.totalDedWeek"))),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "list-tit right-read" }, [
        _vm._v(_vm._s(_vm.$t("lang.host.violationRecords"))),
      ]),
      _c("div", { staticClass: "list-search-box right-read" }, [
        _c("div", { staticClass: "search-input" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.hostId,
                expression: "hostId",
              },
            ],
            staticClass: "input",
            attrs: { placeholder: _vm.$t("lang.vio.hostessID"), type: "text" },
            domProps: { value: _vm.hostId },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.hostId = $event.target.value
              },
            },
          }),
          _c("img", {
            staticClass: "search-icon",
            attrs: {
              src: require("@/assets/packageAssets/views/P2_Page/Violation/vava/search_black.png"),
              alt: "",
            },
            on: {
              click: function ($event) {
                return _vm.handleSearch(_vm.hostId)
              },
            },
          }),
        ]),
        _c(
          "div",
          { staticClass: "search-select", on: { click: _vm.handleTimePop } },
          [
            _vm.chooseTime
              ? _c("span", [
                  _vm._v(
                    _vm._s(_vm.handleMoment(_vm.chooseTime, "YYYY-MM-DD"))
                  ),
                ])
              : _c("span", [_vm._v(_vm._s(_vm.$t("lang.dl.thisWeek")))]),
            _c("img", {
              class: { activeTime: _vm.showPop },
              attrs: {
                src: require("@/assets/packageAssets/common/arrow06.png"),
                alt: "",
              },
            }),
          ]
        ),
        _c("div", { staticClass: "refresh", on: { click: _vm.handleClear } }, [
          _c("img", {
            attrs: {
              src: require("@/assets/packageAssets/views/P2_Page/Violation/vava/refresh.png"),
              alt: "",
            },
          }),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "list-header right-read" },
        _vm._l(_vm.tableName, function (item, index) {
          return _c("div", { key: index, staticClass: "tableName" }, [
            _vm._v(_vm._s(item)),
          ])
        }),
        0
      ),
      _c(
        "van-list",
        {
          staticClass: "list-data-box",
          attrs: {
            finished: _vm.finished,
            "loading-text": " ",
            "finished-text": _vm.$t("lang.noMore"),
            offset: "200",
          },
          on: { load: _vm.onLoad },
          model: {
            value: _vm.loading,
            callback: function ($$v) {
              _vm.loading = $$v
            },
            expression: "loading",
          },
        },
        [
          _vm._l(_vm.listData, function (item, index) {
            return _c(
              "div",
              { key: index, staticClass: "list-data right-read" },
              [
                _c("div", { staticClass: "avatar-box" }, [
                  _c("img", {
                    staticClass: "avatar",
                    attrs: { src: _vm._f("imgPath")(item.avatar), alt: "" },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "copy-id",
                      on: {
                        click: function ($event) {
                          return _vm.copyId(item.presentId)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "id" }, [
                        _vm._v(_vm._s(item.presentId)),
                      ]),
                      _c("img", {
                        staticClass: "copy",
                        attrs: {
                          src: require("@/assets/packageAssets/views/P2_Page/Violation/vava/copy_pink.png"),
                          alt: "",
                        },
                      }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "opinion" }, [
                  _vm._v(" " + _vm._s(item.punishReason) + " "),
                ]),
                _c("div", { staticClass: "time" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.handleMoment(item.punishTime, "YYYY-MM-DD")) +
                      " "
                  ),
                ]),
                _c("div", { staticClass: "beans-num" }, [
                  _vm._v(" " + _vm._s(item.punishAmount) + " "),
                  _c("img", {
                    staticClass: "beans",
                    attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                  }),
                ]),
              ]
            )
          }),
          _vm.listData && !_vm.listData.length
            ? _c("div", { staticStyle: { width: "100%", height: "100px" } })
            : _vm._e(),
        ],
        2
      ),
      _c("CTimeDay", {
        attrs: { showPop: _vm.showPop, "min-date": _vm.minDate },
        on: { handleCurrentDate: _vm.handleCurrentDate },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }